export function initSections() {
  /* section animations */
  const animatedSections = document.querySelectorAll("[data-animated]");

  animatedSections.forEach((section) => {
    // Читаем атрибут
    const thresholdAttr = section.getAttribute("data-animated") || "center";

    // Вычисляем rootMargin в зависимости от режима
    let rootMargin = "0px 0px 0px 0px";

    switch (thresholdAttr) {
      case "top":
        // Триггер срабатывает раньше (как будто threshold выше)
        // Сдвигаем нижнюю границу вьюпорта вверх
        rootMargin = "-30% 0px 30% 0px";
        break;

      case "center":
        // Центр — нейтральное значение
        rootMargin = "0px 0px 0px 0px";
        break;

      case "bottom":
        // Триггер срабатывает позже, когда элемент почти снизу
        rootMargin = "30% 0px -30% 0px";
        break;
    }

    // Мобильный / десктопный threshold (как у тебя)
    const threshold = window.innerWidth <= 768 ? 0.25 : 0.45;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
          } else {
            entry.target.classList.remove("animated");
          }
        });
      },
      {
        threshold,
        rootMargin, // <-- добавили
      }
    );

    observer.observe(section);
  });

  // video observer (ленивая загрузка видео)
  const isMobile = window.innerWidth <= 768;
  const videos = document.querySelectorAll("video[data-lazyvideo]");
  const anchorToVideo = new WeakMap();

  // безопасный запуск воспроизведения
  const playSafely = (v) => {
    // если уже можно играть — играем
    const tryPlay = () =>
      v.play().catch(() => {
        /* проглатываем, повторим позже */
      });

    if (v.readyState >= 2) {
      // HAVE_CURRENT_DATA
      tryPlay();
      return;
    }
    // подождём, пока появятся метаданные/кадры
    const onCanPlay = () => {
      v.removeEventListener("canplay", onCanPlay);
      tryPlay();
    };
    v.addEventListener("canplay", onCanPlay, { once: true });
    // на всякий — инициируем загрузку
    try {
      v.load();
    } catch {}
  };

  const ensureLoaded = (v) => {
    // Проверяем, если видео уже в процессе загрузки или загружено
    if (v.dataset.loading === "1" || v.dataset.loaded === "1") {
      return;
    }

    // Помечаем, что начинаем загрузку
    v.dataset.loading = "1";

    // 1) Сначала — атрибуты для автоплея (до начала загрузки!)
    v.muted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    v.setAttribute("playsinline", "");

    // 2) Проставляем реальные src
    v.querySelectorAll("source[data-src]").forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute("data-src");
    });

    // 3) Начинаем загрузку и отмечаем loaded только после метаданных
    try {
      v.load();
    } catch {}

    const markLoaded = () => {
      v.dataset.loaded = "1";
      v.removeEventListener("loadedmetadata", markLoaded);
    };

    if (v.readyState >= 1) markLoaded(); // метаданные уже есть
    else v.addEventListener("loadedmetadata", markLoaded, { once: true });
  };

  // надёжный сброс к началу (учитываем, что metadata могло не быть)
  const resetVideo = (v) => {
    const doReset = () => {
      try {
        v.currentTime = 0;
        v.pause();
      } catch {}
    };
    if (v.readyState < 1) {
      try {
        v.load();
        v.addEventListener("loadedmetadata", doReset, { once: true });
      } catch {}
    } else {
      doReset();
    }
  };

  const onEnter = (v) => {
    v._inView = true;
    clearTimeout(v._resetTimer);
    ensureLoaded(v);

    v.preload = "auto";

    const isResetMode = v.getAttribute("data-lazyvideo") === "reset";
    if (!isResetMode && v.ended && !v.loop) return;

    playSafely(v);
  };

  const onLeave = (v) => {
    v._inView = false;
    v.pause();

    v.preload = "none";

    if (v.getAttribute("data-lazyvideo") !== "reset") return;

    clearTimeout(v._resetTimer);
    v._resetTimer = setTimeout(() => {
      if (!v._inView) resetVideo(v);
    }, 1000);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const v = anchorToVideo.get(entry.target);
        if (!v) return;
        if (entry.isIntersecting) onEnter(v);
        else onLeave(v);
      });
    },
    {
      root: null,
      rootMargin: isMobile ? "190px 0px 190px 0px" : "400px 0px 400px 0px",
      threshold: 0,
    }
  );

  videos.forEach((v) => {
    // Ранний прэп: если вы не можете править HTML, хотя бы заранее проставим атрибуты
    if (!v.hasAttribute("muted")) v.setAttribute("muted", "");
    if (!v.hasAttribute("playsinline")) v.setAttribute("playsinline", "");
    v.muted = true;
    v.playsInline = true;

    const anchor = v.dataset.lazyanchor
      ? document.querySelector(v.dataset.lazyanchor)
      : v;

    if (!anchor) return;
    anchorToVideo.set(anchor, v);
    v._inView = false;
    io.observe(anchor);
  });
}
